import React, { FC } from 'react';

import ConditionRow from './ConditionRow';

type FirstMessageInConversationConditionProps = {
  index: number;
  onDelete: Function;
};

const FirstMessageInConversationCondition: FC<FirstMessageInConversationConditionProps> = ({ index, onDelete }) => {
  return <ConditionRow index={index} onDelete={onDelete} text="Message initiates a conversation" />;
};

export default FirstMessageInConversationCondition;
